import React from "react";

function Loader() {
    return <div className="flex fixed h-screen w-screen top-0 left-0 justify-center items-center z-[999]"><span className="loader"></span></div>;
}

export default Loader;
